import React, {useState, useRef, useEffect} from 'react';
import UserTeamInvitationListItem from './UserTeamInvitationListItem.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function UserTeamInvitationsList() 
{
    const { user_team_invitations_list } = useCTAL();

    if ((!user_team_invitations_list) || (user_team_invitations_list.length == 0)) return;

    return (
        <>
            <ol class="list-group">
                <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-start">
                    <div class="ms-1 me-auto">
                        Team Invitations ({user_team_invitations_list.length})
                    </div>
                </li>
                { user_team_invitations_list?.map( (member, i) => ( <UserTeamInvitationListItem member={member} key={i} ndx={i}/> )) }
            </ol>
        </>
    );

}